import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { API_BASE_URL, API_KEY } from 'constant/apiConstant';

export const commissionApi = createApi({
  reducerPath: 'CommissionApi',
  tagTypes: ['Post'],
  keepUnusedDataFor: 1,
  baseQuery: fetchBaseQuery({ baseUrl: API_BASE_URL }),
  endpoints: (builder) => ({
    getCommissionDetails: builder.query({
      query: (payload) => ({
        url: `/commission-product/get-product-commission-list?companyId=${payload.companyId}&limit=${payload.limit}&offset=${payload.offset}`,
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'X-API-KEY': API_KEY,
          Authorization: `Bearer ${payload.token}`
        }
      })
    }),

    CommissionDetail: builder.query({
      query: (payload) => ({
        url: `/commission-product/product-commission-detail?productCommissionId=${payload.id}`,
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'X-API-KEY': API_KEY,
          Authorization: `Bearer ${payload.token}`
        }
      }),
      transformResponse: (response) => response.result
    }),

    addCommission: builder.mutation({
      query: (payload) => ({
        url: '/commission-product/add-product-commission',
        method: 'POST',
        body: payload.data,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'X-API-KEY': API_KEY,
          Authorization: `Bearer ${payload.token}`
        }
      }),
      invalidatesTags: ['Post']
    }),

    updateCommission: builder.mutation({
      query: (payload) => ({
        url: '/commission-product/update-product-commission',
        method: 'PUT',
        body: payload.data,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'X-API-KEY': API_KEY,
          Authorization: `Bearer ${payload.token}`
        }
      }),
      invalidatesTags: ['Put']
    }),
    updateProductCommission: builder.mutation({
      query: (payload) => ({
        url: '/commission-product/add-update-product-commission',
        method: 'PUT',
        body: payload.data,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'X-API-KEY': API_KEY,
          Authorization: `Bearer ${payload.token}`
        }
      }),
      invalidatesTags: ['Put']
    })
  })
});

export const {
  useAddCommissionMutation,
  useGetCommissionDetailsQuery,
  useCommissionDetailQuery,
  useUpdateCommissionMutation,
  useUpdateProductCommissionMutation
} = commissionApi;
